// extracted by mini-css-extract-plugin
export default {"mobileImageAndVideoToggleWrapper":"CQzsc1lAkX7f0Dzq55ig"};